import { all, fork } from 'redux-saga/effects';
import { watchAllocationSagas } from 'redux/allocation/allocation.saga';
import { watchContentSaga } from 'redux/content/content.saga';
import { watchStrategySagas } from 'redux/slice/strategy/strategy.saga';

import { watchFetchReportTokenSaga } from './ReportPage.saga';
import { watchAgencyListSaga } from './admin/onboarding/agency/AgencyList.saga';
// import { watchAllocationListFnSaga } from './campaign-planner/AllocationList.saga';
import { watchAdvancedPlannerSagas } from './advanced-planner/AdvancedPlanner.saga';
import { watchAgencySaga } from './agency-onboarding/Agency.saga';
import { watchAgencyAllocatorSaga } from './agency-onboarding/AgencyAllocator.saga';
import { watchAgencyAuthoritiesSaga } from './agency-onboarding/AgencyAuthorities.saga';
import { watchAgencyDocumentSummarySaga } from './agency-onboarding/AgencyDocumentSummary.saga';
import { watchAllocatorSaga } from './agency-onboarding/Allocator.saga';
import watchBasicDetailsSubmission from './agency-onboarding/BasicDetailsSaga';
import { watchGetAgencyCompanyName } from './agency-onboarding/CompanyName.saga';
import { watchStoreDocument } from './agency-onboarding/Document.saga';
import { watchGetAllDocuments } from './agency-onboarding/DocumentColumn.saga';
import { watchAgencyOnboardingSaga } from './agency-onboarding/OwnerDetails.saga';
import { productBucketSaga } from './agency-onboarding/ProductBucket.saga';
import watchSendOTP from './agency-onboarding/SignUp.saga';
import { watchAgencyAllocatorConfigSaga } from './agencyAllocatorConfig/AgencyAllocatorConfig.saga';
import { watchFetchAgentCountSagas } from './agent/AgentCount.saga';
import { watchFetchAgentGroupSagas } from './agent/AgentGroup.saga';
import { watchAgentListSagas } from './agent/AgentList.saga';
import { watchAgentSummarySaga } from './agent/AgentSummary.saga';
import { watchBulkUploadAgentSaga } from './agent/BulkUploadAgent.saga';
import { watchAllAgentPerformanceSaga } from './all-agent-performance/AgentPerformance.saga';
import { watchCreateConfigSaga } from './allocation-config/CreateConfig.saga';
import { watchGetAllocationConfigListSaga } from './allocation-config/GetAllocationList.saga';
import { watchAllocationMappingSagas } from './allocation-mapping/AllocationMapping.saga';
import { watchAllocationDetailSagas } from './allocation/AllocationDetails.saga';
import { watchAllocationListSaga } from './allocation/AllocationListView.saga';
import { watchBulkAllocationSagas } from './allocation/BulkAllocation.saga';
import { watchBulkAllocationListSagas } from './allocation/BulkAllocationList.saga';
import { watchBulkPaymentSagas } from './allocation/BulkPayment.saga';
import { watchBulkPaymentHistorySagas } from './allocation/BulkPaymentHistory.saga';
import { watchAssignChannelSagas } from './allocation/ChannelAllocation.saga';
import { watchPaymentFileSagas } from './allocation/PaymentList.saga';
import { watchUploadFileSagas } from './allocation/UploadAllocation.saga';
import { watchUploadPaymentFileSagas } from './allocation/UploadPaymentFile.saga';
import { watchCallPlannerSagas } from './call-center/CallPlanner.saga';
import { watchFetchCallCampaignSagas } from './callCampaign/CallCampaign.saga';
import { watchCampaignListSaga } from './campaign-planner/CampaignList.saga';
import { watchConfigSaga } from './campaign-planner/ConfigList.saga';
import { watchCreateCampaignSaga } from './campaign-planner/CreateCampaign.saga';
import {
  watchCreateOutreachSaga,
  watchCreateOutreachSuccess,
} from './campaign-planner/CreateOutreach.saga';
import { watchDeleteOutreachSaga } from './campaign-planner/DeleteOutreach.saga';
import { watchOutreachListSaga } from './campaign-planner/OutreachList.saga';
import { watchCampaignSagas } from './campaign/Campaign.saga';
import { watchAgencyVisitSaga as watchComplianceAgencyVisitSaga } from './compliance/agency-visit/AgencyVisit.saga';
import { watchAgencySaga as watchComplianceAgencySaga } from './compliance/agency/Agency.saga';
import { watchDashboardSaga as watchComplianceDashboardSaga } from './compliance/dashboard/Dashboard.saga';
import { watchDocumentSaga as watchComplianceDocumentSaga } from './compliance/document/Document.saga';
import { watchRecordingSaga as watchComplianceRecordingSaga } from './compliance/recording/Recording.saga';
import { watchCRMSagas } from './crm/CRM.saga';
import { watchGetDerivedFieldSaga } from './derived-field/GetDerivedField.saga';
import { watchAgencyDiscoverySaga } from './discovery/AgencyDiscovery.saga';
import { watchEmailTemplates } from './email-templates/EmailTemplates.saga';
import { watchFieldSupervisorDashboardSagas } from './field-supervisor/FieldSupervisorDashboard.saga';
import { watchFieldSupervisorVisitSummary } from './field-supervisor/FieldSupervisorVisitSummary.saga';
import { watchFieldPlannerSagas } from './field/Field.saga';
import { watchFilterSagas } from './filter/Filter.saga';
import { watchDesignationListSaga } from './hierarchy-management/DesignationManagement.saga';
import {
  watchEmployeeProfileDataSaga,
  watchSavedProductBucketSaga,
} from './hierarchy-management/EmployeeProfile.saga';
import { watchHierarchySetupDataSaga } from './hierarchy-management/HierarchySetup.saga';
import { watchIncentiveSaga } from './incentive/Incentive.saga';
import { watchMyLenderSaga } from './lenders/MyLenders.saga';
import { watchUniqueLenderSaga } from './lenders/MyUniqueLenders.saga';
import { watchPendingLenderSaga } from './lenders/PendingLenders.saga';
import { watchRejectedLenderSaga } from './lenders/RejectedLenders.saga';
import { watchReportsSagas } from './report/Report.saga';
import { watchDownloadScoredFileSagas } from './score/DownloadScoredFile.saga';
import { watchScoreListSagas } from './score/ScoreList.saga';
import { watchUploadScoreSagas } from './score/UploadScore.saga';
import { watchGetDefaultPolicySaga } from './settings/compliance/getDefaultPolicy.saga';
import { watchGetGlobalPolicySaga } from './settings/compliance/getGlobalPolicy.saga';
import { watchGetLenderPoliciesSaga } from './settings/compliance/getLenderPolicies.saga';
import { watchGetLMSFieldsSaga } from './settings/loanbook/getLMSFields.saga';
import { watchGetBucketPreferenceSaga } from './settings/preferences/bucketPreference.saga';
import { watchGetChannelPreferenceSaga } from './settings/preferences/channelPreference.saga';
import { watchGetProductPreferenceSaga } from './settings/preferences/productPreference.saga';
import { supervisorDashboardSaga } from './supervisor-dashboard/SupervisorDashboard.saga';
import { watchErrorModalSaga } from './ui/ErrorModal.saga';
import { watchUserEntitiesSaga } from './user/UserEntities.saga';
import { watchGetOnboardDetailsSaga } from './user/UserOnboard.saga';
import { watchUserPermissionSaga } from './user/UserPermission.saga';

function* rootSaga() {
  yield all([
    fork(watchEmailTemplates),
    fork(watchAllAgentPerformanceSaga),
    fork(supervisorDashboardSaga),
    fork(watchFetchReportTokenSaga),
    fork(watchUserEntitiesSaga),
    fork(watchUserPermissionSaga),
    fork(watchMyLenderSaga),
    fork(watchPendingLenderSaga),
    fork(watchCreateConfigSaga),
    fork(watchGetAllocationConfigListSaga),
    fork(watchAllocationSagas),
    fork(watchStrategySagas),
    fork(watchOutreachListSaga),
    fork(watchCreateOutreachSaga),
    fork(watchDeleteOutreachSaga),
    fork(watchConfigSaga),
    fork(watchCreateCampaignSaga),
    fork(watchGetOnboardDetailsSaga),
    fork(watchGetGlobalPolicySaga),
    fork(watchGetDefaultPolicySaga),
    fork(watchCampaignListSaga),
    fork(watchAllocationListSaga),
    fork(watchPaymentFileSagas),
    fork(watchGetDerivedFieldSaga),
    fork(watchDesignationListSaga),
    fork(watchHierarchySetupDataSaga),
    fork(watchEmployeeProfileDataSaga),
    fork(watchSavedProductBucketSaga),
    fork(watchGetChannelPreferenceSaga),
    fork(watchGetLenderPoliciesSaga),
    fork(watchGetProductPreferenceSaga),
    fork(watchGetBucketPreferenceSaga),
    fork(watchCreateOutreachSuccess),
    fork(watchContentSaga),
    fork(watchGetLMSFieldsSaga),
    fork(watchUniqueLenderSaga),
    fork(watchUploadFileSagas),
    fork(watchUploadPaymentFileSagas),
    fork(watchBulkPaymentSagas),
    fork(watchBulkPaymentHistorySagas),
    fork(watchBulkAllocationSagas),
    fork(watchBulkAllocationListSagas),
    fork(watchAllocationDetailSagas),
    // fork(watchAllocationListFnSaga),
    fork(watchAgentListSagas),
    fork(watchAssignChannelSagas),
    fork(watchFetchAgentGroupSagas),
    fork(watchFetchCallCampaignSagas),
    fork(watchFetchAgentCountSagas),
    fork(watchBulkUploadAgentSaga),
    fork(watchCallPlannerSagas),
    fork(watchFieldPlannerSagas),
    fork(watchFieldSupervisorDashboardSagas),
    fork(watchFieldSupervisorVisitSummary),
    fork(watchFetchAgentCountSagas),
    fork(watchAdvancedPlannerSagas),
    fork(watchAgentSummarySaga),
    fork(watchCRMSagas),
    fork(watchFilterSagas),
    fork(watchSendOTP),
    fork(watchBasicDetailsSubmission),
    fork(watchGetAllDocuments),
    fork(watchGetAgencyCompanyName),
    fork(watchStoreDocument),
    fork(watchAllocatorSaga),
    fork(watchAgencyAllocatorSaga),
    fork(watchAgencyAuthoritiesSaga),
    fork(watchAgencyOnboardingSaga),
    fork(watchAgencySaga),
    fork(watchAgencyDocumentSummarySaga),
    fork(watchReportsSagas),
    fork(watchAgencyListSaga),
    fork(watchAllocationMappingSagas),
    fork(watchComplianceDocumentSaga),
    fork(watchComplianceAgencySaga),
    fork(watchComplianceAgencyVisitSaga),
    fork(watchComplianceDashboardSaga),
    fork(watchComplianceRecordingSaga),
    fork(watchCampaignSagas),
    fork(watchRejectedLenderSaga),
    fork(watchIncentiveSaga),
    fork(productBucketSaga),
    fork(watchAgencyDiscoverySaga),
    fork(watchErrorModalSaga),
    fork(watchScoreListSagas),
    fork(watchDownloadScoredFileSagas),
    fork(watchUploadScoreSagas),
    fork(watchAgencyAllocatorConfigSaga),
  ]);
}
export default rootSaga;
